import Topic from 'shared/topic';
import { LocationMediator } from 'shared/vidio_helpers';
import AhoyEvent from 'shared/ahoy_event';

export default class AgeGenderModal {
  constructor(currentUser, content) {
    this.currentUser = currentUser;
    this.content = content;
    this.ageGenderBannerButton = document.querySelector('.content-gating-banner__button--age-gender');
    this.ageGenderFormModal = document.querySelector('.js-age-gender-modal');
    this.ageGenderFormModalClose = document.querySelector('.age-gender-modal__close');
    this.form = document.querySelector('form.js-age-gender-modal__form');
    this.csrfInput = document.querySelector('input.js-age-gender-modal__input-csrf');
    this.submitButton = document.querySelector('button.js-age-gender-modal__form-button');
  }

  init() {
    this.bindAgeGenderBannerButton();
    this.bindAgeGenderFormModalClose();
    this.bindSubmitButton();
    this.modifyFormAttributes();
    Topic.subscribeOnce('content_gating/banner/ready', this.autoOpenByUrl.bind(this));
  }

  onEscapeKey(event){
    if(event.key == 'Escape' || event.key == 'Esc') {
      this.hide();
    }
  }

  autoOpenByUrl() {
    if (LocationMediator.href().indexOf("gating_action=age_gender") > -1) {
      this.show();
    }
  }

  bindAgeGenderBannerButton() {
    if(this.currentUser) {
      this.ageGenderBannerButton.href = '#';

      this.ageGenderBannerButton.addEventListener("click", function(event) {
        this.show();
        event.preventDefault();
      }.bind(this));
    }
  }

  bindAgeGenderFormModalClose() {
    this.ageGenderFormModalClose.addEventListener("click", function() {
      this.hide();
    }.bind(this));
    document.body.addEventListener('keydown', function(event) {
      this.onEscapeKey(event)
    }.bind(this));
  }

  bindSubmitButton() {
    this.submitButton.addEventListener('click', () => {
      AhoyEvent.send('VIDIO::FORM_POPUP', {
        action: 'click',
        content_type: this.content.type,
        content_id: this.content.id,
        feature: 'age gender',
        feature_source: 'content gating'
      });
    });
  }

  modifyFormAttributes() {
    if(!this.currentUser) {
      return;
    }

    let formAction = this.form.getAttribute('action');
    this.form.setAttribute(
      'action',
      formAction.replace('username-placeholder', this.currentUser.username)
    );

    this.csrfInput.setAttribute('value', this.currentUser.token);
  }

  show() {
    this.ageGenderFormModal.classList.remove('hide');
    AhoyEvent.send('VIDIO::FORM_POPUP', {
      action: 'impression',
      content_type: this.content.type,
      content_id: this.content.id,
      feature: 'age gender',
      feature_source: 'content gating'
    });
  }

  hide() {
    this.ageGenderFormModal.classList.add('hide');
  }
}
